import TillBasedSource from "./From/TillBasedSource";
import RoleBasedTarget from "./To/RoleBasedTarget";
import Shipping from "./Shipping";
import Comment from "./Comment";
import React, {Fragment, useEffect, useState} from "react";
import BoxEditor from "../../BoxEditor";
import NewDefault from "./Buttons/NewDefault";
import PoolList from "./Picking/PoolList";
import List from "./List";
import Other from "./Other";
import {connect} from "src/store";
import {loadComponentById} from "../../../../utils/components";

export default connect((state) => {
    return {
        context: state.app.context
    }
})((componentProps) => {

    const [stores, setStores] = useState([]);
    let storeRequest;
    useEffect(() => {
        storeRequest && storeRequest.abort();
        if (componentProps.context?.store?.id) {
            storeRequest = loadComponentById("store", componentProps.context?.store?.id, {"supply_stores": {"id": ""}});
            storeRequest.then(({supply_stores}) => {
                setStores(supply_stores?.map(({id}) => id) || []);
            })
        } else {
            setStores([]);
        }
    }, [componentProps.context?.store?.id]);

    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    // {...{...componentProps, props: {...componentProps.props, getProps: (name) => {return {...componentProps.props.getProps(name),fields: ["provider"]}}}}}
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                {actionButtons}
                <NewDefault {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <Other {...componentProps} tag={Fragment} />
                    <div className="row form-row">
                        <div className="col-md-6">
                            <TillBasedSource {...componentProps} />
                        </div>
                        <div className="col-md-6">
                            <RoleBasedTarget
                                {...componentProps}
                                filter={[
                                    {
                                        filters: [
                                            {
                                                field: "partner",
                                                value: componentProps.context.partner.partner_id
                                            },
                                            {
                                                field: "id",
                                                value: stores.length ? stores : [-1],
                                                operator: "in"
                                            }
                                        ],
                                        operator: "or"
                                    }
                                ]}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                        {/*<Notenum {...componentProps} />*/}
                    </div>
                    <Comment {...componentProps} />
                    {props.values.target && <PoolList {...componentProps} control={{visible: false}}/>}
                </form>
            }
        </Editor>
    </Fragment>;
});